import { useContext } from 'react';
import { AlertContext } from '@features/contexts/AlertProvider';

export const useAlert = () => useContext(AlertContext);
